import React from 'react';
export const ListboxWrapper = ({ children }: { children: React.ReactNode }) => (
	<div className="w-full max-w-[860px]">
		{children}
	</div>
);
